// @flow
import React from 'react';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.scss';

type Props = {
    pageCount: number,
    breakClassName: string,
    onPageChange: Function,
    forcePage: number,
    pageRangeDisplayed: number
}

const Pagination = (props: Props) => {
  return (
    <div>
      <ReactPaginate
        previousLabel={'<<'}
        nextLabel={'>>'}
        breakLabel={''}
        pageCount={props.pageCount}
        marginPagesDisplayed={0}
        pageRangeDisplayed={props.browser && props.browser.greaterThan && props.browser.greaterThan.tablet ? 6 : 4}
        onPageChange={page => props.onPageChange(page)}
        forcePage={props.currentPage - 1}
        activeClassName={styles.selected}
        containerClassName={styles.ctr}
        breakClassName={props.breakClass}
      />
    </div>
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/common/pagination/Pagination.js